import {SurfaceArea} from '@mintdata-wsp/pub/view/SurfaceArea';
import {SurfaceDnDGlass} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/SurfaceDnDGlass';
import {componentContextTypes, IComponentContext} from '@mintdata/mint-kit/api/components/ComponentContext';
import {PopupGlassView} from '@mintdata/mint-kit/impl/components/popover/PopupGlassView';
import {PopupManager} from '@mintdata/mint-kit/impl/components/popover/PopupManager';
import * as React from 'react';
import {NonPassiveEventListeners} from '@mintdata/mint-kit/impl/events/Events';

const styles = require('./ApplicationView.less');

export class ApplicationView extends React.Component<any, any>
{
    public static readonly childContextTypes = componentContextTypes;

    public getChildContext():IComponentContext
    {
        return {
            popupManager: PopupManager.getInstance(),
            nonPassiveEventListeners: NonPassiveEventListeners.getInstance()
        };
    }

    public render():JSX.Element
    {
        return <div className={styles.appRoot}>
            <SurfaceArea />
            <PopupGlassView />
            <SurfaceDnDGlass />
        </div>;
    }
}
